/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Vacations_ErrorInputs */

const es_tools_legajox_vacations_error = /** @type {(inputs: Tools_Legajox_Vacations_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar vacaciones de Legajox`)
};

const en_tools_legajox_vacations_error = /** @type {(inputs: Tools_Legajox_Vacations_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox vacations`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox vacations" |
*
* @param {Tools_Legajox_Vacations_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_vacations_error = /** @type {((inputs?: Tools_Legajox_Vacations_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Vacations_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_vacations_error(inputs)
	return en_tools_legajox_vacations_error(inputs)
});
export { tools_legajox_vacations_error as "tools.legajox.vacations_error" }